'use client'

import { init, Types } from '@amplitude/analytics-browser'
import { useFlag } from '@unleash/nextjs'
import { useEffect } from 'react'

const AmplitudeInit = () => {
  const enableAmplitude = useFlag('enableAmplitude')

  useEffect(() => {
    const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY as string

    const logLevel = Types.LogLevel.None

    if (!enableAmplitude) {
      return
    }

    init(amplitudeApiKey, {
      defaultTracking: false,
      logLevel,
    })
  }, [enableAmplitude])

  return null
}

export default AmplitudeInit
